import React, { createContext, useContext, useState, useCallback } from "react";

const QuoteContext = createContext(null);

export const useQuote = () => {
  const ctx = useContext(QuoteContext);
  if (!ctx) throw new Error("useQuote must be used within QuoteProvider");
  return ctx;
};

export const QuoteProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [product, setProduct] = useState(null); // null = show product picker first
  const [prefill, setPrefill] = useState({});

  const openQuote = useCallback((productKey = null, prefillData = {}) => {
    // 'assurance' tab → show product picker (energie is now a valid PRODUCTS key)
    if (productKey === "assurance") {
      setProduct(null);
    } else {
      setProduct(productKey);
    }
    setPrefill(prefillData || {});
    setOpen(true);
  }, []);
  const closeQuote = useCallback(() => {
    setOpen(false);
    setTimeout(() => {
      setProduct(null);
      setPrefill({});
    }, 300);
  }, []);

  return (
    <QuoteContext.Provider value={{ open, openQuote, closeQuote, product, setProduct, prefill }}>
      {children}
    </QuoteContext.Provider>
  );
};
